export { DocumentText as default } from './DocumentText';
